import { formatDateTime } from '../../../utils/utils';
import { Box, CircularProgress } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import UserCellDisplay from './UserCellDisplay';
import FailedIngestionCount from '../../../components/FailedIngestionCount';

export const adminEmailJobColumns = (navigate) => [
	{
		field: 'user',
		headerName: 'User',
		flex: 3,
		renderCell: (params) => {
			const user = params.value;
			if (!user) return 'Unknown';

			return <UserCellDisplay user={user} />;
		},
	},
	{
		field: 'provider',
		headerName: 'Provider',
		cellClassName: 'capitalize-text',
		flex: 2,
	},
	{
		field: 'trigger_type',
		headerName: 'Type',
		flex: 2,
		valueGetter: (value) => (value === 'manual' ? 'Manual' : 'Automatic'),
	},
	{
		field: 'range_start',
		headerName: 'Range Start',
		flex: 2,
		valueGetter: (value) => formatDateTime(value),
	},
	{
		field: 'range_end',
		headerName: 'Range End',
		flex: 2,
		valueGetter: (value) => formatDateTime(value),
	},
	{
		field: 'created_at',
		headerName: 'Created At',
		flex: 2,
		valueGetter: (value) => formatDateTime(value),
	},
	{
		field: 'status',
		headerName: 'Status',
		cellClassName: 'capitalize-text',
		flex: 2,
		renderCell: (params) => (
			<Box
				sx={{
					display: 'flex',
					columnGap: 1,
					alignItems: 'center',
				}}
			>
				<span>{params.value}</span>
				{(params.value === 'starting' ||
					params.value === 'ingesting' ||
					params.value === 'syncing') && <CircularProgress size={16} />}
			</Box>
		),
	},
	{
		field: 'status_detail',
		headerName: 'Status Detail',
		flex: 2,
		renderCell: (params) => {
			const isIngestedWithCounts =
				params?.row?.status === 'ingested' &&
				params?.row?.statistics &&
				Object.prototype.hasOwnProperty.call(
					params?.row?.statistics,
					'emails_ingested'
				);

			const isSyncedWithCounts =
				params?.row?.status === 'synced' &&
				params?.row?.statistics &&
				Object.prototype.hasOwnProperty.call(
					params?.row?.statistics,
					'interaction_messages_synced'
				);

			if (isIngestedWithCounts) {
				const emailCount =
					params.row.statistics.emails_ingested.toLocaleString();
				const failedEmailCount =
					params.row.statistics.failed_emails_ingested?.toLocaleString() || 0;

				return (
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<span style={{ color: '#808080' }}>{emailCount} emails pulled</span>
						{failedEmailCount > 0 && (
							<FailedIngestionCount count={failedEmailCount} />
						)}
					</Box>
				);
			}

			if (isSyncedWithCounts) {
				const emailCount =
					params.row.statistics.interaction_messages_synced.toLocaleString();
				return <span>{emailCount} emails synced to CRM</span>;
			}

			if (params?.row?.status_detail) {
				return <span>{JSON.stringify(params?.row?.status_detail)}</span>;
			}

			return null;
		},
	},
	{
		field: 'actions',
		headerName: 'Actions',
		type: 'actions',
		flex: 1,
		getActions: (params) => [
			<GridActionsCellItem
				key={`view-${params.row.id}`}
				icon={<VisibilityIcon />}
				onClick={() =>
					navigate(
						`/tenants/${params.row.tenant_id}/email-sync-admin/${params.row.id}/records`
					)
				}
				label='View Records'
			/>,
		],
	},
];
